import React from 'react';

import { LogOutButton } from 'packages/sidebar/ui/LogOutButton';
import { SideBar } from 'packages/sidebar/ui/SideBar';

import 'source/borrower/borrower.scss';

// @jendevelops TODO: either consolidate with fremium eventually, or just outright delete
export const GSRouterSideBarTEMP = () => {
  return (
    <SideBar>
      <LogOutButton />
    </SideBar>
  );
};
